import React from "react";
import { Box } from "@mantine/core";
import Logo from "../Logo/Logo";
import styles from "./BrandedLoadingOverlay.module.css";

export interface BrandedLoadingOverlayProps {
  visible: boolean;
  background?: string;
  className?: string;
  style?: React.CSSProperties;
}

const BrandedLoadingOverlay: React.FC<BrandedLoadingOverlayProps> = ({
  visible,
  background = "#ffffff",
  className,
  style,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Box
      className={`${styles.container} ${className || ""}`}
      style={{
        backgroundColor: background,
        ...style,
      }}
    >
      <div className={styles.logoContainer}>
        <Logo variant="icon" size="xxl" className={styles.logo} />
      </div>
    </Box>
  );
};

export default BrandedLoadingOverlay;
